import React, {useEffect, useState} from "react";
import {Proteins} from "./protein.enum.js";
import {BsAppIndicator} from "react-icons/bs";
import {Carbos} from "./carbos.enum.js";
import {Fats} from "./fats.enum.js";

export const Macros = () => {

    const [indicatedProtein, setIndicatedProtein] = useState(null)
    const [desiredProtein, setDesiredProtein] = useState(null)
    const [indicatedProteinWeight, setIndicatedProteinWeigth] = useState(0)

    const [indicatedCarbo, setIndicatedCarbo] = useState(null)
    const [desiredCarbo, setDesiredCarbo] = useState(null)
    const [indicatedCarboWeight, setIndicatedCarboWeigth] = useState(0)

    const [indicatedFats, setIndicatedFats] = useState(null)
    const [desiredFats, setDesiredFats] = useState(null)
    const [indicatedFatsWeight, setIndicatedFatsWeigth] = useState(0)



    const handleChange = (e, setState, enumObject) => {
        const value = e.target.value;
        console.log(value)

        const alimentoSeleccionado = Object.values(enumObject).find(alimento => alimento.name === value);

        if (alimentoSeleccionado) {
            console.log(alimentoSeleccionado);
        }
        setState(alimentoSeleccionado)
    };

    const calculateEquivalency = (indicatedFood, desiredFood, quantity ) => {
        console.log("entro a la funcion", indicatedFood, desiredFood)
        if (!indicatedFood || !desiredFood) return
        console.log("1paso")
        if (!indicatedFood.netMacro || !desiredFood.netMacro) return
        console.log("2paso")

        if (!quantity) return
       const indicatednetMacro =  (quantity / indicatedFood.totalWeight) * indicatedFood.netMacro
        console.log("indicadas, ",indicatednetMacro)
        return  ((indicatednetMacro * desiredFood.totalWeight) / desiredFood.netMacro).toFixed(3)
    }

    return (
        <div className={"bg-white w-screen px-5 py-20 lg:px-20 h-screen m-0 p-0 overflow-auto"}>
            {/*paso 1*/}
            <div className={` mb-2  lg:mt-12 lg:text-3xl lg:mb-5 text-left flex items-center justify-start
                transition-all duration-1000 ease-out`}>
                <h3 className='text-3xl font-bold text-sbPallet-accent'>1</h3>
                <p className="font-bold  text-bgBlack ml-3 ">Cantidad de proteina a consumir</p>
            </div>

            <div>
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 ">Cantidad a
                    convertir en gramos</label>
                <input type="text" id="first_name"
                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  w-full lg-w-[25%] p-2.5  "
                       placeholder="Cantidad (g)" onChange={e => setIndicatedProteinWeigth(e.target.value)}/>
            </div>
            <select id="countries"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full lg-w-[25%] p-2.5 "
                    onChange={e => handleChange(e, setIndicatedProtein, Proteins)}>
                <option selected>Selecciona el alimento a convertir</option>

                {Object.values(Proteins).map((alimento, index) => (
                    <option key={index} value={alimento.name}>
                        {alimento.name}
                    </option>
                ))}
            </select>


            <select id="countries"
                    className="bg-gray-50 border mt-10 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full lg-w-[25%]  p-2.5 "
                    onChange={e => handleChange(e, setDesiredProtein, Proteins)}>{">"}
                <option selected>Selecciona el alimento deseado</option>

                {Object.values(Proteins).map((alimento, index) => (
                    <option key={index} value={alimento.name}>
                        {alimento.name}
                    </option>
                ))}
            </select>

            <p className="text-bgBlack mt-3  ">Debes consumir : <span className={"font-bold"}>{calculateEquivalency(indicatedProtein, desiredProtein, indicatedProteinWeight)
            }</span> gramos</p>


            {/*paso 2*/}
            <div className={` mb-2 mt-20  lg:mt-12 lg:text-3xl lg:mb-5 text-left flex items-center justify-start
                transition-all duration-1000 ease-out`}>
                <h3 className='text-3xl font-bold text-sbPallet-accent'>2</h3>
                <p className="font-bold  text-bgBlack ml-3 ">Cantidad de hidratos a consumir</p>
            </div>

            <div>
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 ">Cantidad a
                    convertir en gramos</label>
                <input type="text" id="first_name"
                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  w-full lg-w-[25%] p-2.5  "
                       placeholder="Cantidad (g)" onChange={e => setIndicatedCarboWeigth(e.target.value)}/>
            </div>
            <select id="countries"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full lg-w-[25%] p-2.5 "
                    onChange={e => handleChange(e, setIndicatedCarbo, Carbos)}>
                <option selected>Selecciona el alimento a convertir</option>

                {Object.values(Carbos).map((alimento, index) => (
                    <option key={index} value={alimento.name}>
                        {alimento.name}
                    </option>
                ))}
            </select>


            <select id="countries"
                    className="bg-gray-50 border mt-10 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full lg-w-[25%]  p-2.5 "
                    onChange={e => handleChange(e, setDesiredCarbo, Carbos)}>{">"}
                <option selected>Selecciona el alimento deseado</option>

                {Object.values(Carbos).map((alimento, index) => (
                    <option key={index} value={alimento.name}>
                        {alimento.name}
                    </option>
                ))}
            </select>

            <p className="  text-bgBlack mt-3  ">Debes consumir : <span className={"font-bold"}>{        calculateEquivalency(indicatedCarbo, desiredCarbo, indicatedCarboWeight)
            } </span>gramos</p>


            {/*paso 3*/}
            <div className={` mb-2 mt-20  lg:mt-12 lg:text-3xl lg:mb-5 text-left flex items-center justify-start
                transition-all duration-1000 ease-out`}>
                <h3 className='text-3xl font-bold text-sbPallet-accent'>3</h3>
                <p className="font-bold  text-bgBlack ml-3 ">Cantidad de grasas a consumir</p>
            </div>

            <div>
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 ">Cantidad a
                    convertir en gramos</label>
                <input type="text" id="first_name"
                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  w-full lg-w-[25%] p-2.5  "
                       placeholder="Cantidad (g)" onChange={e => setIndicatedFatsWeigth(e.target.value)}/>
            </div>
            <select id="countries"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full lg-w-[25%] p-2.5 "
                    onChange={e => handleChange(e, setIndicatedFats, Fats)}>
                <option selected>Selecciona el alimento a convertir</option>

                {Object.values(Fats).map((alimento, index) => (
                    <option key={index} value={alimento.name}>
                        {alimento.name}
                    </option>
                ))}
            </select>


            <select id="countries"
                    className="bg-gray-50 border mt-10 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full lg-w-[25%]  p-2.5 "
                    onChange={e => handleChange(e, setDesiredFats, Fats)}>{">"}
                <option selected>Selecciona el alimento deseado</option>

                {Object.values(Fats).map((alimento, index) => (
                    <option key={index} value={alimento.name}>
                        {alimento.name}
                    </option>
                ))}
            </select>

            <p className="  text-bgBlack mt-3  ">Debes consumir : <span className={"font-bold"}>{        calculateEquivalency(indicatedFats, desiredFats, indicatedFatsWeight)
            } </span>gramos</p>


        </div>
    )
}
